import * as React from "react";
import type { SVGProps } from "react";
const SvgLightning01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m10.222 14.489-.71 7.111 9.244-9.956L13.778 8.8l.71-6.4-9.244 9.956z"
    />
  </svg>
);
export default SvgLightning01;
